// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ActualsProjectPerformanceSummary {
  readonly id: string;
  readonly name: string;
  readonly status: Enums.ActualsPerformanceStatus;
  readonly plannedActualPercentageMix: string | null;
  readonly plannedActualPercentageAsphalt: string | null;
  readonly plannedActualPercentageAggregate: string | null;
  readonly customer: string | null;
  readonly customerId: string | null;
  readonly lastDispatchedTicketDate: string | null;
  readonly firstDispatchedTicketDate: string | null;
  readonly varianceMix: string | null;
  readonly varianceAsphalt: string | null;
  readonly varianceAggregate: string | null;
  readonly actualVolumeMix: string | null;
  readonly actualVolumeAsphalt: string | null;
  readonly actualVolumeAggregate: string | null;
  readonly quotedVolumeMix: string | null;
  readonly quotedVolumeAsphalt: string | null;
  readonly quotedVolumeAggregate: string | null;
  readonly backlogVolumeMix: string | null;
  readonly backlogVolumeAsphalt: string | null;
  readonly backlogVolumeAggregate: string | null;
  readonly plannedVolumeMix: string | null;
  readonly plannedVolumeAsphalt: string | null;
  readonly plannedVolumeAggregate: string | null;
  readonly estimatedEndDate: DateTime | null;
  readonly estimatedStartDate: DateTime | null;
  readonly isArchived: boolean;
  readonly isDispatchOnly: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.status = data.status === undefined ? Enums.ActualsPerformanceStatus.AtRisk : data.status;
    this.plannedActualPercentageMix =
      data.plannedActualPercentageMix === undefined ? null : data.plannedActualPercentageMix;
    this.plannedActualPercentageAsphalt =
      data.plannedActualPercentageAsphalt === undefined
        ? null
        : data.plannedActualPercentageAsphalt;
    this.plannedActualPercentageAggregate =
      data.plannedActualPercentageAggregate === undefined
        ? null
        : data.plannedActualPercentageAggregate;
    this.customer = data.customer === undefined ? null : data.customer;
    this.customerId = data.customerId === undefined ? null : data.customerId;
    this.lastDispatchedTicketDate =
      data.lastDispatchedTicketDate === undefined ? null : data.lastDispatchedTicketDate;
    this.firstDispatchedTicketDate =
      data.firstDispatchedTicketDate === undefined ? null : data.firstDispatchedTicketDate;
    this.varianceMix = data.varianceMix === undefined ? null : data.varianceMix;
    this.varianceAsphalt = data.varianceAsphalt === undefined ? null : data.varianceAsphalt;
    this.varianceAggregate = data.varianceAggregate === undefined ? null : data.varianceAggregate;
    this.actualVolumeMix = data.actualVolumeMix === undefined ? null : data.actualVolumeMix;
    this.actualVolumeAsphalt =
      data.actualVolumeAsphalt === undefined ? null : data.actualVolumeAsphalt;
    this.actualVolumeAggregate =
      data.actualVolumeAggregate === undefined ? null : data.actualVolumeAggregate;
    this.quotedVolumeMix = data.quotedVolumeMix === undefined ? null : data.quotedVolumeMix;
    this.quotedVolumeAsphalt =
      data.quotedVolumeAsphalt === undefined ? null : data.quotedVolumeAsphalt;
    this.quotedVolumeAggregate =
      data.quotedVolumeAggregate === undefined ? null : data.quotedVolumeAggregate;
    this.backlogVolumeMix = data.backlogVolumeMix === undefined ? null : data.backlogVolumeMix;
    this.backlogVolumeAsphalt =
      data.backlogVolumeAsphalt === undefined ? null : data.backlogVolumeAsphalt;
    this.backlogVolumeAggregate =
      data.backlogVolumeAggregate === undefined ? null : data.backlogVolumeAggregate;
    this.plannedVolumeMix = data.plannedVolumeMix === undefined ? null : data.plannedVolumeMix;
    this.plannedVolumeAsphalt =
      data.plannedVolumeAsphalt === undefined ? null : data.plannedVolumeAsphalt;
    this.plannedVolumeAggregate =
      data.plannedVolumeAggregate === undefined ? null : data.plannedVolumeAggregate;
    this.estimatedEndDate = DateHelpers.ParseServerNullableDate(data.estimatedEndDate);
    this.estimatedStartDate = DateHelpers.ParseServerNullableDate(data.estimatedStartDate);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.isDispatchOnly = data.isDispatchOnly === undefined ? false : data.isDispatchOnly;
  }

  static zero(): ActualsProjectPerformanceSummary {
    const zeroValues: ExcludeMethodsDeep<ActualsProjectPerformanceSummary> = {
      id: NIL_UUID,
      name: '',
      status: Enums.ActualsPerformanceStatus.AtRisk,
      plannedActualPercentageMix: null,
      plannedActualPercentageAsphalt: null,
      plannedActualPercentageAggregate: null,
      customer: null,
      customerId: null,
      lastDispatchedTicketDate: null,
      firstDispatchedTicketDate: null,
      varianceMix: null,
      varianceAsphalt: null,
      varianceAggregate: null,
      actualVolumeMix: null,
      actualVolumeAsphalt: null,
      actualVolumeAggregate: null,
      quotedVolumeMix: null,
      quotedVolumeAsphalt: null,
      quotedVolumeAggregate: null,
      backlogVolumeMix: null,
      backlogVolumeAsphalt: null,
      backlogVolumeAggregate: null,
      plannedVolumeMix: null,
      plannedVolumeAsphalt: null,
      plannedVolumeAggregate: null,
      estimatedEndDate: null,
      estimatedStartDate: null,
      isArchived: false,
      isDispatchOnly: false,
    };
    return new ActualsProjectPerformanceSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsProjectPerformanceSummaryWireFormat = {
  id: string;
  name: string;
  status: string;
  plannedActualPercentageMix: string | null;
  plannedActualPercentageAsphalt: string | null;
  plannedActualPercentageAggregate: string | null;
  customer: string | null;
  customerId: string | null;
  lastDispatchedTicketDate: string | null;
  firstDispatchedTicketDate: string | null;
  varianceMix: string | null;
  varianceAsphalt: string | null;
  varianceAggregate: string | null;
  actualVolumeMix: string | null;
  actualVolumeAsphalt: string | null;
  actualVolumeAggregate: string | null;
  quotedVolumeMix: string | null;
  quotedVolumeAsphalt: string | null;
  quotedVolumeAggregate: string | null;
  backlogVolumeMix: string | null;
  backlogVolumeAsphalt: string | null;
  backlogVolumeAggregate: string | null;
  plannedVolumeMix: string | null;
  plannedVolumeAsphalt: string | null;
  plannedVolumeAggregate: string | null;
  estimatedEndDate: string | null;
  estimatedStartDate: string | null;
  isArchived: boolean;
  isDispatchOnly: boolean;
};

type NewActualsProjectPerformanceSummaryProps = PartialDeep<
  ActualsProjectPerformanceSummary,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectPerformanceSummary: (
  props: NewActualsProjectPerformanceSummaryProps,
) => ActualsProjectPerformanceSummary = (props) => new ActualsProjectPerformanceSummary(props);

type NewActualsProjectPerformanceSummaryFromWireFormatProps = PartialDeep<
  ActualsProjectPerformanceSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectPerformanceSummaryFromWireFormat: (
  props: NewActualsProjectPerformanceSummaryFromWireFormatProps,
) => ActualsProjectPerformanceSummary = (props) => new ActualsProjectPerformanceSummary(props);
